import React from "react";
import OrderCheckout from "../../components/User/OrderCheckout";

export default function UserOrderCheckoutPage() {
  return <OrderCheckout />;
}